import {
  React,
  useState,
  useEffect,
  useRef,
  Fragment,
} from 'react';
import { connect } from 'react-redux';
import { getData } from '../../../services/fetch-service';
import CoBotAvatar from '../../CoBotAvatar';

// import Level8 from '../Level8';

import Link from '../Link';

const SubChilds = (props) => {
  const { id, locale } = props;
  // const { actionProvider } = props;
  const [options, setOptions] = useState([]);
  // const [data, setData] = useState([]);
  const [showBot, toggleBot] = useState(false);
  const messageEndRef = useRef(null);
  useEffect(() => {
    getData(`Chat/GetChatBoot?ParentId=${id}&Gjuha=${locale}`).then((response) => {
      setOptions(response.data);
      // setData(response.data[0].childs);
    });
    setTimeout(() => {
      toggleBot(true)
    }, 400)
  }, [id]);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [options])

  // const updatedHandler = data.map((item) => {
  //   return { ...item };
  // })

  let description;
  if (showBot === false) {
    description = (
      <div className="react-chatbot-kit-chat-bot-message">
        <div className="chatbot-loader-container">
          <svg id="dots-10" width="50px" height="21px" viewBox="0 0 132 58" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" fill="none">
              <g id="chatbot-loader-10" fill="#fff">
                <circle id="chatbot-loader-dot1-10" cx="25" cy="30" r="13" />
                <circle id="chatbot-loader-dot2-10" cx="65" cy="30" r="13" />
                <circle id="chatbot-loader-dot3-10" cx="105" cy="30" r="13" />
              </g>
            </g>
          </svg>
        </div>
        <div className="react-chatbot-kit-chat-bot-message-arrow" />
      </div>
    )
  } else {
    description = (
      <div className="react-chatbot-kit-chat-bot-message">
        {options.map((option) => {
          return (
            <span>{option.description}</span>
          );
        })}
        <div className="react-chatbot-kit-chat-bot-message-arrow" />
      </div>
    )
  }

  return (
    <Fragment>
      {options.map((items) => {
        return (
          <Fragment key={items.id}>
            {items.description && (
              <div className="react-chatbot-kit-chat-bot-message-container show-message">
                <CoBotAvatar />
                {description}
              </div>
            )}
            {
              (items.url || items.linkName !== '') && (
                !items.isOtherSource ? (
                  <Link
                    to={items.url}
                    title={items.linkName}
                    name="link"
                    aria-label="link"
                    rel="link"
                  />
                ) : (
                  <a href={items.url} target="_blank" rel="noreferrer" className="url-link">
                    <img alt="attachment" src="/images/chatbot/attachment.png" />
                    <h1 className="url-header">
                      {items.linkName}
                    </h1>
                  </a>
                )
              )
            }
            <div className="level 2">
              {
                items.hasChilds === true ? (
                  <Fragment key={items.id}>
                    {/* <Level8 options={updatedHandler} title="Options" /> */}
                  </Fragment>
                ) : ('')
              }

            </div>
          </Fragment>
        );
      })}

      <div ref={messageEndRef} />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  locale: state.locale,
});

export default connect(mapStateToProps)(SubChilds);
